import { Autocomplete, Button, Input } from "src/components";
import crossIcon from "src/assets/cross.svg";
import { useState } from "react";
import { useToast } from "src/hooks/useToast";
import { eInvoiceStatusUpdate } from "src/services/invoice-api";
import { useEventStatus } from "src/hooks/useEventStatus";

interface InvoiceRejectProps {
  onCloseModal: () => void;
  einvoice_dtl_id: number;
  primary_key: number;
  onSuccess: () => void;
}

const InvoiceReject = ({ onCloseModal, einvoice_dtl_id, primary_key, onSuccess }: InvoiceRejectProps) => {
  const [remarks, setRemarks] = useState<string>("");
  const [rejectionCategory, setRejectionCategory] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { withEventCheck } = useEventStatus();
  const rejectionReasons = [
    { key: "other", value: "Other" },
    { key: "irn mismatch", value: "IRN Mismatch" },
    { key: "E-invoice duplicate", value: "E-invoice Duplicate" },
  ];

  const { toast } = useToast();

  const fetchCurrentEInvoice = async () => {
    onSuccess();
  };

  const handleRejectInvoice = async () => {
    setIsLoading(true);
    const payload = {
      data: {
        einvoice_dtl_id: einvoice_dtl_id,
        einvoice_status: "rejected",
        remarks: remarks,
        reason: rejectionCategory,
      },
      primary_key: primary_key,
      event_type: "E_INVOICE_STATUS_UPDATE",
    };

    try {
      const response = await eInvoiceStatusUpdate(payload);
      console.log("res", response);
      const res = await withEventCheck(() => fetchCurrentEInvoice(), response?.data?.data?.eventStreamCreated?.streamId);
      console.log("res", res);
      toast({ description: "Invoice rejected successfully", variant: "default" });
      onCloseModal();
    } catch (error: any) {
      toast({ description: error?.response?.data?.message, variant: "destructive" });
    } finally {
      setIsLoading(false);
      onCloseModal();
    }
  };

  return (
    <div className="flex flex-col gap-y-2 w-[345px] mx-auto bg-white p-4 border border-gray-300 shadow-lg rounded-xl">
      <div className="flex justify-between items-center">
        <p className="text-normal py-1 font-semibold text-[#1B1A1F]">Reject E-Invoice</p>
        <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
          <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
        </Button>
      </div>
      <p className="text-sm mt-2 font-normal text-[#666666]">Select Rejection Reason</p>
      <Autocomplete
        inputClassName="w-full py-2"
        placeholder="Select Rejection Reason"
        suggestionList={rejectionReasons}
        displayKey="value"
        uniqueKey="key"
        onSelectionChange={(e: any) => setRejectionCategory(e?.key)}
      />
      <p className="text-sm mt-2 font-normal text-[#666666]">Remarks</p>
      <Input value={remarks} onChange={(e) => setRemarks(e.target.value)} placeholder=" " className="py-2 border border-gray-300 rounded-md" />
      <div className="flex justify-end gap-x-2 pt-2">
        <Button className="font-normal h-8 bg-gray-200 rounded-md border border-gray-300 shadow-sm" onClick={onCloseModal}>
          Back
        </Button>{" "}
        <Button
          isLoading={isLoading}
          loaderSize="medium"
          className="font-normal text-white h-8 border rounded-md border-[#8051FF] shadow-sm bg-[#8051FF]"
          onClick={handleRejectInvoice}
        >
          Proceed
        </Button>
      </div>
    </div>
  );
};

export default InvoiceReject;
